import React from 'react';

import Tick from './Icons/Tick';
import Instagram from './Icons/Instagram';
import Twitter from './Icons/Twitter';
import Menu from './Icons/Menu';
import Cross from './Icons/Cross';
import ChevronLeft from './Icons/ChevronLeft';
import ChevronRight from './Icons/ChevronRight';

export enum fillTypes {
    white = 'fill-white',
    black = 'fill-black',
    hotPink = 'fill-hotPink',
    none = 'fill-transparent'
}

export interface props {
    size?: React.SVGAttributes<SVGSVGElement>['width'] | React.SVGAttributes<SVGSVGElement>['height'],
    fill?: fillTypes,
    viewBox?: React.SVGAttributes<SVGSVGElement>['viewBox'],
    children: React.ReactNode,
    className?: 'shrink-0'
}

const Icon = ({ children, className, fill, size, viewBox }: props): JSX.Element => {
    const fillClass = fill || '';

    return (
        <svg viewBox={viewBox} width={size} height={size} className={`${className} ${fillClass}`}>
            {children}
        </svg>
    );
};

Icon.defaultProps = {
    fill: fillTypes.black,
    size: 48,
    viewBox: '0 0 60 60'
};

Icon.Tick = Tick;
Icon.Instagram = Instagram;
Icon.Twitter = Twitter;
Icon.Menu = Menu;
Icon.Cross = Cross;
Icon.ChevronLeft = ChevronLeft;
Icon.ChevronRight = ChevronRight;

export default Icon;
